<template>
  <div class="accordion-faq wow move-up">
    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-1 class="faq-title">
          <div class="flex w-100 justify-content-between h-100 align-items-center">
            <div>Exklusiver Zugang zum mhp-finance.de Portal</div>
            <fa-icon :icon="['fas', 'minus-circle']" />
          </div>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            Mit dem exklusiven Zugang zum MHP-Finance-Portal genießen Sie die Vorteile rund um den Kauf und Verkauf von
            Kunstbüchern. Damit Sie jederzeit attraktive Angebote erhalten, legen wir einen großen Wert auf die Qualität
            der angebotenen Bibliotheksstrukturen. Die Gesamtheit, der auf dem MHP-Finance-Portal angebotenen Bibliothekssamlung,
            wird vor ihrer Veröffentlichung nach unseren Erfahrungswerten auf die Struktur, den Aufbau und Zustand
            überprüft.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-2 class="faq-title">
          <div class="flex w-100 justify-content-between h-100 align-items-center">
            <div>Vermittlung von Kunstbüchern</div>
            <fa-icon :icon="['fas', 'minus-circle']" />
          </div>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            Wir verfügen über ein breit angelegtes Netzwerk von Kooperationspartnern: darunter zertifizierte
            Kunsthändler, professionelle Verkaufsdienste und Staatsbibliotheken. Mittels des weitverzweigten Netzwerks
            können wir zwischen Ihnen als Käufer und/oder Verkäufer vermitteln. Mit einem exklusiven Zugang zu unserem
            MHP-Portal können Sie diese Leistungen auch online genießen.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header header-tag="header">
        <b-button block v-b-toggle.accordion-3 class="faq-title">
          <div class="flex w-100 justify-content-between h-100 align-items-center">
            <div>Zusätzliche Leistungen</div>
            <fa-icon :icon="['fas', 'minus-circle']" />
          </div>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion">
        <b-card-body>
          <b-card-text>
            Als exklusiver Kunde des MHP-Finance-Portals bieten wir Ihnen bei Interesse die Vermittlung eines
            Kunstgutachtens an. Mit unserer Expertise im Bereich der Faksimiles und weiteren Produkten stehen wir Ihnen
            durch eine kostenlose Beratung und Betreuung selbstverständlich ebenso zur Seite. Unsere zusätzlichen
            Leistungen umfassen darüber hinaus den Datenabgleich, die Zustandsbeurkundung, die Ausgabenerfassung Ihrer
            Bibliothek und das visuelle Einpflegen Ihrer Produkte in das MHP-Portal.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
};
</script>